import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('client', ['client']),
    ...mapState('manager', ['manager'])
  },

  watch: {
    $route () {
      if (this.$route.params.clientId === undefined) {
        this.resetClient()
      } else {
        this.attemptFetchingClient()
      }

      if (this.$route.params.managerId === undefined) {
        this.resetManager()
      } else {
        this.attemptFetchingManager()
      }
    }
  },

  created () {
    this.attemptFetchingClient()
    this.attemptFetchingManager()
  },

  beforeDestroy () {
    this.resetClient()
    this.resetManager()
  },

  methods: {
    ...mapActions('client', ['getClient', 'resetClient']),
    ...mapActions('manager', ['getManager', 'resetManager']),

    attemptFetchingClient () {
      if (this.$route.params.clientId !== undefined) {
        if (this.client === undefined || this.client === null) {
          this.getClient(this.$route.params.clientId)
        }
      }
    },

    attemptFetchingManager () {
      if (this.$route.params.managerId !== undefined) {
        if (this.manager === undefined || this.manager === null) {
          this.getManager(this.$route.params.managerId)
        }
      }
    }
  }
}
